import React, { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { editLicenseType, getUser, listCompanies, listLicenseTypes } from '../../services/service';
import MenuItem from '@mui/material/MenuItem';
import './ListPageStyles.css'
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { FormDialog } from '../FormDialog';
import { APISelectField } from '../APISelectField';
import { APITextField } from '../APITextField';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';



// const validationSchema = Yup.object({
//   name: Yup
//     .string('Insira o nome do Modelo da Licença')
//     .required('Campo obrigatório'),
//   durationUnit: Yup.string()
//     .oneOf(['lifetime', 'years', 'months', 'days'])
//     .required('Necessário escolher a unidade da duração!'),
// })


export default function EditLicenseModel({ licenseTypeData, sx, setOpenModal, openModal, onLicenseChanged }) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();

  const handleClose = () => {
    setOpenModal(false);
  };


  const formik = useFormik({
    initialValues: {
      name: licenseTypeData.name,
      description: licenseTypeData.description,
      types: licenseTypeData.types || [],
      max_tags: !!licenseTypeData.config ? !!licenseTypeData.config.historian ? licenseTypeData.config.historian.max_tags : null : null,
      max_control_loops: !!licenseTypeData.config ? !!licenseTypeData.config.pid ? licenseTypeData.config.pid.max_control_loops : null : null,
      durationUnit: "lifetime"
    },
    enableReinitialize: true,
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      var payload = {
        name: formik.values.name,
        description: formik.values.description,
        types: formik.values.types,
        durationValue: formik.values.durationValue,
        durationUnit: formik.values.durationUnit,
        config: {
          historian: {
            max_tags: formik.values.max_tags
          },
          pid: {
            max_control_loops: formik.values.max_tags
          }
        }
      }
      editLicenseType(
        licenseTypeData.id, payload
      ).then((response) => {
        console.log(response['status'])
        if (response.status === 200) {
          handleClose()
          onLicenseChanged()
          formik.resetForm()
        } else {
          console.log(response.data)
        }
      }).catch((err) => {
        setErrors(err.response.data);
      }).finally((resp) => {
        setLoading(false)
      })
    }
  })

  const licenseTypesOptions = [
    { label: "Historian", value: "historian" },
    { label: "PID", value: "pid" },
    { label: "AIoT-Anomaly", value: "anomaly" },
    { label: "AIoT-Forecast", value: "forecast" },
  ]

  return (
    <Box sx={sx}>
      <FormDialog
        title={"Editar Modelo de Licença"}
        open={openModal}
        onDismiss={handleClose}
        onSubmit={formik.handleSubmit}
        formWidth={500}
        loading={loading}
      >
        <APITextField
          id="license-type-name"
          name="name"
          label="Nome"
          disabled={loading}
          value={formik.values.name}
          onChange={formik.handleChange}
          errors={errors?.name}
          variant="standard"
          style={{ width: "100%", margin: '0.5rem 0rem' }}
        />
        <APITextField
          id="license-type-description"
          label="Descrição"
          name="description"
          multiline
          disabled={loading}
          value={formik.values.description}
          onChange={formik.handleChange}
          errors={errors?.description}
          variant="standard"
          style={{ width: "100%", margin: '0.5rem 0rem' }}
        />
        <Typography align='center' style={{ margin: '0.5rem' }}>
          Duração
        </Typography>
        <FormGroup row>
          <Row>
            <Col>
              <APITextField
                id="license-type-duration-value"
                label=""
                name="durationValue"
                placeholder='Qtde'
                type="number"
                // style={{ width: "100%", paddingRight: "0.5rem" }}
                disabled={loading || formik.values.durationUnit === "lifetime"}
                value={formik.values.durationValue}
                onChange={formik.handleChange}
                errors={errors?.durationValue}
                variant="outlined"
                InputLabelProps={{
                  shrink: false
                }}
              />
            </Col>
            <Col>
              <APISelectField
                id="license-type-duration-unit"
                name="durationUnit"
                // sx={{ width: "100%", paddingRight: "0.5rem" }}
                variant="outlined"
                value={formik.values.durationUnit}
                onChange={formik.handleChange}
                defaultValue={"lifetime"}
                label=""
                disabled={loading}
              >
                <MenuItem value="lifetime" selected>Vitalícia</MenuItem>
                <MenuItem value="years">Anos</MenuItem>
                <MenuItem value="months">Meses</MenuItem>
                <MenuItem value="days">Dias</MenuItem>
              </APISelectField>
            </Col>
          </Row>
        </FormGroup>
        <Typography align='center' style={{ marginTop: '1rem' }}>
          Produto
        </Typography>
        <FormGroup row>
          <div style={{ margin: 'auto' }}>
            {licenseTypesOptions.map(el => (
              <FormControlLabel
                control={<Checkbox onChange={formik.handleChange} checked={formik.values.types.includes(el.value)} />}
                label={el.label}
                value={el.value}
                key={el.value}
                name="types"
              />
            ))}
          </div>
        </FormGroup>
        <Row>
          <Col>
            <APITextField
              id="license-type-max-tags"
              label="Máximo de Tags"
              name="max_tags"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("historian")}
              value={formik.values.max_tags}
              onChange={formik.handleChange}
              errors={errors?.max_tags}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-max-control-loops"
              label="Máximo de Malhas"
              name="max_control_loops"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("pid")}
              value={formik.values.max_control_loops}
              onChange={formik.handleChange}
              errors={errors?.max_control_loops}
              variant="standard"
            />
          </Col>
        </Row>
        <Row>
        <Col>
            <APITextField
              id="license-type-max-anomalies"
              label="Máximo de Anomalias"
              name="max_anomalies"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("anomaly")}
              value={formik.values.max_anomalies}
              onChange={formik.handleChange}
              errors={errors?.max_anomalies}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-calc-window"
              label="Frequência de Calculos"
              name="calc_frequency"
              placeholder='minutos'
              type="number"
              disabled={loading || !formik.values.types.includes("anomaly")}
              value={formik.values.calc_frequency_anomaly}
              onChange={formik.handleChange}
              errors={errors?.calc_frequency_anomaly}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-max-forecasts"
              label="Máximo de Predições"
              name="max_forecasts"
              placeholder='Qtde'
              type="number"
              disabled={loading || !formik.values.types.includes("forecast")}
              value={formik.values.max_forecasts}
              onChange={formik.handleChange}
              errors={errors?.max_forecasts}
              variant="standard"
            />
          </Col>
          <Col>
            <APITextField
              id="license-type-calc-window"
              label="Frequência de Calculos"
              name="calc_frequency"
              placeholder='minutos'
              type="number"
              disabled={loading || !formik.values.types.includes("forecast")}
              value={formik.values.calc_frequency_forecast}
              onChange={formik.handleChange}
              errors={errors?.calc_frequency_forecast}
              variant="standard"
            />
          </Col>
        </Row>
      </FormDialog>
    </Box >
  );
}